import React from 'react';

const clampPercent = (value) => (value >= 100 ? 100 : value <= 0 ? 0 : value);

export default function ProgressBar({
    progress,
    isActive,
    campaignPercentage,
    isTopModule,
    // Optional { percent, label }: a tick at the share of the flight elapsed.
    marker,
}) {
    const percentage = clampPercent(progress);
    const hasMarker = marker && Number.isFinite(Number(marker.percent));

    return (
        <div
            className={`${
                isActive ? 'animate-pulse' : ''
            } relative w-full opacity-75 group-hover:opacity-100 duration-300 transition-opacity bg-gray-100 h-1 rounded-full`}>
            {hasMarker && (
                <span
                    data-testid="progress-marker"
                    role="img"
                    aria-label={marker.label}
                    title={marker.label}
                    tabIndex={0}
                    className="absolute bg-gray-700 rounded-sm"
                    style={{
                        left: `${clampPercent(Number(marker.percent))}%`,
                        // Centered on the track, overhanging it above and below.
                        top: '50%',
                        width: '2px',
                        height: '12px',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
            )}
            <div
                style={{ width: `${percentage}%` }}
                className={`${
                    isActive
                        ? percentage >= 101 || campaignPercentage >= 101
                            ? 'bg-red-800'
                            : isTopModule
                            ? 'bg-blue-400'
                            : 'bg-green-400'
                        : 'bg-gray-400'
                } mt-2 h-0.5 py-0.5 rounded-full`}></div>
        </div>
    );
}
